// extracted by mini-css-extract-plugin
export default {"col":"NotFound_col__cSqti","floating":"NotFound_floating__L8038"};